import { render, staticRenderFns } from "./DashboardView.vue?vue&type=template&id=747bada5&scoped=true"
import script from "./DashboardView.vue?vue&type=script&lang=ts"
export * from "./DashboardView.vue?vue&type=script&lang=ts"
import style0 from "./DashboardView.vue?vue&type=style&index=0&id=747bada5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "747bada5",
  null
  
)

export default component.exports